import { useState } from "react";
import axios from "axios";
import { Send } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const fields = [
  { key: "value_orientation", label: "Value Orientation" },
  { key: "governance_framing", label: "Governance Framing" },
  { key: "founder_composition", label: "Founder Composition" },
  { key: "country", label: "Country" },
  { key: "founder_names", label: "Founder Names" }
];

export const CorrectionForm = ({ app, onSuccess }) => {
  const [formData, setFormData] = useState({
    app_id: app.id, field_name: "value_orientation", current_value: "",
    suggested_value: "", reason: "", submitted_by: ""
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await axios.post(`${API}/corrections`, {
        ...formData, current_value: String(app[formData.field_name] || "")
      });
      onSuccess();
    } catch (error) {
      void 0;
    } finally {
      setSubmitting(false);
    }
  };

  const inputClass = "w-full px-3 py-2 bg-background border border-input rounded-lg text-sm";

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="correction-form">
      <div className="p-3 bg-muted rounded-lg">
        <p className="font-medium">{app.product_name}</p>
        <p className="text-sm text-muted-foreground">{app.tagline}</p>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1.5">Field to Correct</label>
        <select value={formData.field_name} onChange={(e) => setFormData(f => ({ ...f, field_name: e.target.value }))} className={inputClass} data-testid="correction-field">
          {fields.map(f => (<option key={f.key} value={f.key}>{f.label} (current: {String(app[f.key] || "unknown")})</option>))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium mb-1.5">Suggested Value</label>
        <input type="text" required value={formData.suggested_value} onChange={(e) => setFormData(f => ({ ...f, suggested_value: e.target.value }))} placeholder="What should it be?" className={inputClass} data-testid="correction-value" />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1.5">Reason / Source</label>
        <textarea value={formData.reason} onChange={(e) => setFormData(f => ({ ...f, reason: e.target.value }))} rows={2} placeholder="Why is this correction needed?" className={inputClass} data-testid="correction-reason" />
      </div>
      <button type="submit" disabled={submitting} data-testid="correction-submit-btn"
        className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-primary text-primary-foreground rounded-lg hover:bg-primary/90 disabled:opacity-50 font-medium">
        {submitting ? <div className="spinner" /> : <Send className="w-4 h-4" />}
        Submit Correction
      </button>
    </form>
  );
};
